/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_MiddayInputs */

const en_eta_window_midday = /** @type {(inputs: Eta_Window_MiddayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10:00 – 14:00`)
};

const ja_eta_window_midday = /** @type {(inputs: Eta_Window_MiddayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10:00 – 14:00`)
};

const fr_eta_window_midday = /** @type {(inputs: Eta_Window_MiddayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10h00 – 14h00`)
};

const de_eta_window_midday = /** @type {(inputs: Eta_Window_MiddayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10:00 – 14:00`)
};

/**
* | output |
* | --- |
* | "10:00 – 14:00" |
*
* @param {Eta_Window_MiddayInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_midday = /** @type {((inputs?: Eta_Window_MiddayInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_MiddayInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_midday(inputs)
	if (locale === "ja") return ja_eta_window_midday(inputs)
	if (locale === "fr") return fr_eta_window_midday(inputs)
	return de_eta_window_midday(inputs)
});